import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-arrow-forward",
  "use": "icon-arrow-forward-usage",
  "viewBox": "0 0 512 512",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 512 512\" id=\"icon-arrow-forward\">\r\n<polygon points=\"287.3,256 160,383.6 192.3,416 352,256 352,256 352,256 192.3,96 160,128.4 \" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol